import { formatNumber, formatToKM } from "Helpers/numbers";

export const formatRate = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) =>
  options?.isKM
    ? `${formatToKM(Number(val))}%`
    : `${formatNumber(Number(val))}%`;

export const formatPercentage = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) =>
  options?.isKM
    ? `${formatToKM(Number(val))}%`
    : `${formatNumber(Number(val))}%`;

export const formatRank = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) => `${formatNumber(Number(val) * 100)}%`;

/** Y-axis / width-measurement ticks: same rounding as formatRate. */
export const formatPercentAxisTick = (value: number | string) =>
  `${formatNumber(Number(value))}%`;

export const formatRatio = (
  val: unknown,
  currency?: string,
  options?: { isKM?: boolean },
) =>
  options?.isKM
    ? `${formatToKM(Number(val), 1)}x`
    : `${Number(val).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      })}x`;
